import { render, staticRenderFns } from "./AttestationNew.vue?vue&type=template&id=0952765c&scoped=true&"
import script from "./AttestationNew.vue?vue&type=script&lang=js&"
export * from "./AttestationNew.vue?vue&type=script&lang=js&"
import style0 from "./AttestationNew.vue?vue&type=style&index=0&id=0952765c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0952765c",
  null
  
)

export default component.exports